<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <sidebar-item
          v-if="checkPermission('view venta', ' ')"
          :link="{
            name: 'Venta',
            img:'/img/menu/Venta.png',
            path: '/venta',
          }"
        ></sidebar-item>

        <sidebar-item
          v-if="checkPermission('view boletos', ' ')"
          :link="{
            name: 'Boletos',
            img:'/img/menu/Boletos.png',
            path: '/boletos',
          }"
        ></sidebar-item>
        
       <sidebar-item
        v-if="checkPermission('view facturacion', ' ')"
          :link="{
            name: 'Facturación',
            img:'/img/menu/Facturacion.png',
            path: '/facturacion',
          }"
        ></sidebar-item>

        <sidebar-item
        v-if="checkPermission('view facturacion', ' ')"
          :link="{
            name: 'Facturación Global',
            img:'/img/menu/Facturacion.png',
            path: '/facturacionglobal',
          }"
        ></sidebar-item>

        <sidebar-item
          v-if="checkPermission('view abordaje', 'view abordaje equipaje')"
          :link="{
            name: 'Abordaje',
            img:'/img/menu/Abordaje.png',
            path: '/abordaje',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="checkPermission('view documentar', ' ')"
          :link="{
            name: 'Documentar',
            img:'/img/menu/Documentar.png',
            path: '/documentar',
          }"
        ></sidebar-item>
       
        <sidebar-item
          v-if="checkPermission('view movimientos caja', ' ')"
          :link="{
            name: 'Movimiento de Caja',
            img:'/img/menu/Cajas.png',
            path: '/movimientos',
          }"
        ></sidebar-item>

        <sidebar-item
          v-if="checkPermission('view arqueos', ' ')"
          :link="{
            name: 'Arqueo',
            img:'/img/menu/Facturacion.png',
            path: '/arqueos',
          }"
        ></sidebar-item>

        <sidebar-item
          v-if="checkPermission('view reporte boletos', 'view reporte salidas')"
          :link="{
            name: 'Reportes',
            img:'/img/menu/Facturacion.png',
          }"
          >
            <sidebar-item
              v-if="checkPermission('view reporte boletos', ' ')"
              :link="{ name: 'Boletos', path: '/reporte/boletos' }"
            />
            <sidebar-item
              v-if="checkPermission('view reporte salidas', ' ')"
              :link="{ name: 'Salidas y Servicios', path: '/reporte/salidas' }"
            />
          </sidebar-item>

        <sidebar-item
          opened
          v-if="checkPermissionGestion()"
          :link="{
            name: 'Gestión',
            img:'/img/menu/Gestion.png',
          }"
        >
          <sidebar-item
            v-if="checkPermission('view opciones', ' ')"
            :link="{ name: 'Opciones', path: '/gestion/opciones' }"
          />
          <sidebar-item
            v-if="checkPermission('view autorizaciones evento', ' ')"
            :link="{ name: 'Autorizaciones', path: '/gestion/autorizaciones' }"
          />
          <sidebar-item
            v-if="checkPermission('view ciudades', ' ')"
            :link="{ name: 'Ciudades', path: '/gestion/ciudades' }"
          />
          <sidebar-item
            v-if="checkPermission('view terminales', ' ')"
            :link="{ name: 'Terminales', path: '/gestion/terminales' }"
          />
          <sidebar-item
            v-if="checkPermission('view dispositivos', ' ')"
            :link="{ name: 'Dispositivos', path: '/gestion/dispositivos' }"
          />
          <sidebar-item
            v-if="checkPermission('view agencias', ' ')"
            :link="{ name: 'Agencias', path: '/gestion/agencias' }"
          />
          <sidebar-item
            v-if="checkPermission('view roles', ' ')"
            :link="{ name: 'Roles', path: '/gestion/roles' }"
          />
          <sidebar-item
            v-if="checkPermission('view users', ' ')"
            :link="{ name: 'Usuarios', path: '/gestion/users' }"
          />
          <sidebar-item
            v-if="checkPermission('view layouts', ' ')"
            :link="{ name: 'Layouts de Autobus', path: '/gestion/layouts' }"
          />
          <sidebar-item
            v-if="checkPermission('view unidades', ' ')"
            :link="{ name: 'Unidades de Autobus', path: '/gestion/unidades' }"
          />
          <sidebar-item
            v-if="checkPermission('view operadores', ' ')"
            :link="{ name: 'Operadores', path: '/gestion/operadores' }"
          />
          <sidebar-item
          v-if="checkPermissionGestion()"
          :link="{
            name: 'Rutas',
            img:'/img/menu/Gestion.png',
          }"
          >
            <sidebar-item
              v-if="checkPermission('view tramos', ' ')"
              :link="{ name: 'Tramos', path: '/gestion/tramos' }"
            />
            <sidebar-item
              v-if="checkPermission('view rutas', ' ')"
              :link="{ name: 'Rutas con Tramos', path: '/gestion/rutas' }"
            />
          </sidebar-item>
          <sidebar-item
            v-if="checkPermission('view precios', ' ')"
            :link="{ name: 'Precios', path: '/gestion/precios' }"
          />
          <sidebar-item
            v-if="checkPermission('view descuentos', ' ')"
            :link="{ name: 'Descuentos', path: '/gestion/descuentos' }"
          />
          <sidebar-item
          v-if="checkPermissionGestion()"
          :link="{
            name: 'Corridas',
            img:'/img/menu/Gestion.png',
          }"
          >
          <sidebar-item
            v-if="checkPermission('view corridas', ' ')"
            :link="{ name: 'Corridas', path: '/gestion/corridas' }"
          />
            <sidebar-item
              v-if="checkPermission('view canje masivo', ' ')"
              :link="{ name: 'Canje Masivo de Boletos', path: '/gestion/canje' }"
            />
          </sidebar-item>
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import { FadeTransition } from "vue2-transitions";
import Vuex from "vuex";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    FadeTransition,
  },
  data() {
    return {
      permissions: [],
    };
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
    checkPermission(permission, permission2){
      for(let i = 0; i < this.permissions.length; i++){
        let permissions = this.permissions[i].name;
          if (permissions === permission || permissions === permission2) {
              return true;
          }
      }
      return false;
    },
    checkPermissionGestion(){
      const permission = ['view opciones', 'view ciudades', 'view terminales', 'view dispositivos', 
      'view agencias', 'view roles', 'view usuarios',  
      'view layouts', 'view unidades', 'view operadores', 'view tramos', 'view rutas',
      'view descuentos', 'view corridas', 'view venta', 'view boletos', 'view arqueos',
      'view cajas','view documentar','view abordaje', 'view canje masivo', 'view facturacion', 'view autorizaciones evento'
      ]
      for(let i = 0; i < this.permissions.length; i++){
        let permissions = this.permissions[i].name;
        for(let j = 0; j < permission.length; j++){
          if (permissions === permission[j]) {
              return true;
          }
        }
      }
      return false;
    },
  },
  mounted() {
    this.initScrollbar(), this.$store.dispatch("profile/me");
  },
  computed: {
    ...Vuex.mapState({
      me: (state) => state.profile.me,
    }),
  },
  watch: {
    me: {
      handler: function (val) {
        this.permissions = val.relationships.permissions;
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
body.g-sidenav-hidden {
  #purchase-button,
  #demo-button,
  #star-button,
  #docs-button {
    margin-left: 8px;
    margin-right: 8px;
    padding: 11px 0px;
  }
}
body.g-sidenav-show {
  #purchase-button,
  #demo-button,
  #star-button,
  #docs-button {
    margin-left: 20px;
    margin-right: 20px;
    padding: 11px 0px;
  }
}
</style>
